var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5503 4.2474L16.1916 3.61623C16.8694 2.9491 16.8694 1.86748 16.1916 1.20036C15.5137 0.533231 14.4147 0.533231 13.7369 1.20036L13.0956 1.83153M15.5503 4.2474L9.07699 10.6183L6.25942 11.3437C6.03509 11.3937 5.83451 11.1963 5.88532 10.9755L6.62232 8.20246L13.0956 1.83153M15.5503 4.2474L13.0956 1.83153M5.82232 2.67363H2.69995C1.59538 2.67363 0.699951 3.56907 0.699951 4.67364V14.7C0.699951 15.8046 1.59538 16.7 2.69995 16.7H12.6281C13.7327 16.7 14.6281 15.8046 14.6281 14.7V11.4604",
    stroke: "#9F9F9F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.1a88bc3aab7f763c919e431fdfd2e563.svg";
export { ForwardRef as ReactComponent };